// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"243":"92260063","313":"2288ab43","878":"31d6cfe0"}[chunkId] + ".chunk.css";
};